import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import SearchCriteria from "../../Utils/SearchCriteria";
import { Container, Alert } from "reactstrap";
import { useDispatch } from "react-redux";
import errors from "../../Constants/errors.json";
import Mapping from "../../Utils/Mapping";
import {
  // getAdminUserDetails,
  errorWhileFetch,
  setUserList,
} from "../../../actions/admin";
import { Loading } from "../../../loader/Loading";
import { Link } from "react-router-dom";
import DocumentTitle from "react-document-title";
import { enAPI } from "../../../config";
import InfiniteScrollTable from "../../Common/InfiniteScrollCognito";

function ModifyAdminSearch() {
  const dispatch = useDispatch();
  // const [modal, openModal] = useState(false);
  // const [property, PropertySet] = useState(undefined);
  const { usersList, searchAttributes, lastKey } = useSelector(
    (state) => state?.admin
  );

  const isLoading = useSelector((state) => state?.fetch?.isLoading);
  const error = useSelector((state) => state?.error?.error_obj);
  const authToken = useSelector((state) => state?.auth?.token);

  // const clearErrorFn = () => {
  //   dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  // };
  // const clearUsersListFn = () => {
  //   dispatch({ type: "ADMIN_USERS_LIST", data: { usersList: undefined } });
  // };
  // const getAdminUserDetailsFn = (username) =>
  //   dispatch(getAdminUserDetails(username));
  const errorWhileFetchFn = (err) => dispatch(errorWhileFetch(err));
  const setUserListFn = (...props) => dispatch(setUserList(...props));

  // const setProperty = (value) => {
  //   PropertySet(value);
  //   toggle();
  // };

  // const toggle = () => {
  //   if (!modal) {
  //     openModal(!modal);
  //   }
  // };

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch({ type: "ADMIN_USERS_LIST", data: { usersList: undefined } });
    return () => {
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "ADMIN_USERS_LIST", data: { usersList: undefined } });
    };
  }, [dispatch]);

  const cols = [
    {
      label: "UserName",
      dataKey: "email",
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <Link
            to={`/modifyadmin/${rowData.Username}`}
            style={{
              backgroundColor: "none",
              borderColor: "none",
              color: "blue",
            }}
          >
            {rowData.email}
          </Link>
        );
      },
    },
    {
      label: "First Name",
      dataKey: "given_name",
      width: "100",
    },
    {
      label: "Last Name",
      dataKey: "family_name",
      width: "100",
    },
  ];

  return (
    <DocumentTitle title={"Doorkeeper | Modify Admin"}>
      <Container style={{ padding: "0% 2%" }}>
        <h5 style={{ marginLeft: "42%" }}>Modify Admin</h5>
        <SearchCriteria manageAdmin={true} modifyAdminList={true} />
        {isLoading && !error && <Loading />}
        {usersList && usersList.length > 0 && searchAttributes && !error && (
          /*<SearchResults
                    columns={columns}
                    data={this.props.usersList}
                    tableHeight={'50vh'}
                />*/
          <InfiniteScrollTable
            columnData={cols}
            data={usersList}
            gridClassName={"gridClass"}
            rowHeight={45}
            page={"viewSearch"}
            url={`${enAPI}ADMIN_PORTAL/searchusers`}
            lastKey={lastKey}
            authToken={authToken}
            searchAttributes={searchAttributes}
            errorWhileFetch={errorWhileFetchFn}
            setUserList={setUserListFn}
          />
        )}
        {!error && usersList && usersList.length === 0 && !isLoading && (
          <Alert color="info" style={{ textAlign: "center" }}>
            <h6>No records found.</h6>
          </Alert>
        )}
        {error && (
          <Alert color="danger" style={{ textAlign: "center" }}>
            <h5>
              <Mapping dictionary={errors} word={error.errorPath} />
            </h5>
          </Alert>
        )}
      </Container>
    </DocumentTitle>
  );
}

export default ModifyAdminSearch;
